<template>
  <modal name="feedbackConfirmationModal" class="feedbackModal" :height="'auto'">
    <form class="feedback-form" @submit.prevent="handleConfirm">
      <h3 class="title">
        {{$t('confirm_application')}}
      </h3>

      <label class="modal-label" for="categoria">{{$t('category')}}</label>

      <v-select
        :options="categoriaOptions"
        v-model="localCategoria"
        placeholder="Selecione uma categoria"
        :clearable="false"
        :reduce="option => option.value"
        class="modal-select"
      />

      <label class="modal-label" for="confirmation-text">{{$t('justification')}}
        <span v-if="localCategoria === 'Outros'" class="required-asterisk">*</span>
      </label>
      <div class="field text-field">
        <textarea
          id="confirmation-text"
          v-model="localMotivo"
          class="feedback-textarea"
          :class="{ 'error': showError }"
          rows="4"
          :placeholder="$t('change_plate_feedback_min_length_placeholder')"
        ></textarea>
        <div v-if="showError" class="error-message">
          {{$t('change_plate_feedback')}}
        </div>
      </div>

      <div class="button-div feedback-button-div">
        <button type="button" class="button ghost" @click="handleCancel">
          <i class="fas fa-times"></i> {{$t('cancel')}}
        </button>

        <button type="submit" class="button" :disabled="!isValid">
          {{$t('confirm')}}
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import { t } from 'i18next';
import vSelect from "vue-select";

export default {
  name: "FeedbackConfirmationModal",
  	components:{
		'v-select': vSelect,
	},
  props: {
    categoria: {
      type: String,
      default: ""
    },
    motivo: {
      type: String,
      default: ""
    },
    showError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categoriaOptions: [
        { label: "A combinação entre os pratos foi ruim", value: "A combinação entre os pratos foi ruim" },
        { label: "Houve repetição de cor", value: "Houve repetição de cor" },
        { label: "Houve repetição de ingredientes", value: "Houve repetição de ingredientes" },
        { label: "Houve repetição de modo de preparo", value: "Houve repetição de modo de preparo" },
        { label: "Houve repetição de mais de uma característica", value: "Houve repetição de mais de uma característica" },
        { label: "Houve repetição de prato", value: "Houve repetição de prato" },
        { label: "Houve repetição de grupo de prato", value: "Houve repetição de grupo de prato" },
        { label: "Para reduzir o custo do cardápio", value: "Para reduzir o custo do cardápio" },
        { label: "Ajustar inconsistência contratual", value: "Ajustar inconsistência contratual" },
        { label: "Outros", value: "Outros" }
      ]
    };
  },
  computed: {
    localCategoria: {
      get() {
        return this.categoria;
      },
      set(value) {
        this.$emit('updateCategoria', value);
      }
    },
    localMotivo: {
      get() {
        return this.motivo;
      },
      set(value) {
        this.$emit('updateMotivo', value);
      }
    },
    isValid() {
      const categoriaValida = this.categoria !== "";
      const motivoValido = this.categoria === "Outros" ? this.motivo.trim().length >= 15 : true; // sempre opcional, exceto "outras"
      return categoriaValida && motivoValido;
    }
  },
  methods: {
    handleConfirm() {
      if (!this.isValid) {
        this.$emit('showError');
        return;
      }
      this.$emit('confirm');
    },

    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../../assets/variables.less");

.feedbackModal {
  z-index: 999 !important;
}

.feedback-textarea {
  width: 100%;
  min-height: 120px;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  font-size: 14px;
  resize: none;
  padding: 8px;
  box-sizing: border-box;
  font-family: inherit;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.feedback-textarea:focus {
  border-color: #e74c3c;
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.15);
  outline: none;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

.button-div {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.button {
  min-width: 150px;
  padding: 6px 15px;
  margin: auto 3px;
}

.ghost {
  background-color: white;
  box-shadow: none;
  color: #dc143d;
  border: 1px solid #dc143d;

  &:hover {
    color: #212146;
    border: 1px solid #212146;
  }
}

.feedback-form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    width: calc(100% - 40px);
    min-height: 400px;
    padding: 20px;

  .field.text-field textarea {
    width: 100%;
    min-height: 300px;
    padding: 16px;
    border: 1px solid #BDBDBD;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: inherit;
    resize: vertical;


  }
}

.modal-label{
  font-weight: 500;
  // padding-bottom: 6px;
}

.modal-select .vs__dropdown-menu {
  height: clamp(9.6rem, 12dvh, 15rem) !important;
}

.modal-select{
  padding-bottom: 6px;
}

.required-asterisk {
  color: red;
}
</style>